<admin-app-header></admin-app-header>
<app-prospecting-nav></app-prospecting-nav>

<div class="settings-page">
    <div class="grid">
        <!-- Prospecting Assignees -->
        <div class="card">
            <h2><i class="fa-solid fa-users"></i> Prospecting Assignees</h2>
            <p class="hint">Toggle which CRM assignees are available for lead assignment in prospecting.</p>

            <div class="loading-state" *ngIf="assigneesLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>

            <ng-container *ngIf="!assigneesLoading">
                <div class="empty-state" *ngIf="!assignees.length">No CRM assignees configured. Add them at <a routerLink="/admin/users">System &gt; Users</a>.</div>

                <div class="assignee-list" *ngIf="assignees.length">
                    <div class="assignee-row" *ngFor="let a of assignees">
                        <span class="assignee-name">{{ a.displayName }}</span>
                        <label class="toggle">
                            <input type="checkbox" [checked]="a.prospectingEnabled" (change)="toggleAssignee(a)" />
                            <span class="toggle-slider"></span>
                        </label>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Scrape Settings -->
        <div class="card">
            <h2><i class="fa-solid fa-gear"></i> Scrape Settings</h2>

            <div class="loading-state" *ngIf="scrapeLoading"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>

            <ng-container *ngIf="!scrapeLoading">
                <div class="scrape-grid">
                    <div>
                        <label class="field-label">Import Page Size</label>
                        <input type="number" class="full" [(ngModel)]="scrape.importPageSize" />
                    </div>
                    <div>
                        <label class="field-label">Max Imports per Tick</label>
                        <input type="number" class="full" [(ngModel)]="scrape.maxImportsPerTick" />
                    </div>
                    <div>
                        <label class="field-label">Max Concurrent Runs</label>
                        <input type="number" class="full" [(ngModel)]="scrape.maxConcurrentRuns" />
                    </div>
                    <div>
                        <label class="field-label">Region Buffer (km)</label>
                        <input type="number" class="full" [(ngModel)]="scrape.regionBufferKm" />
                    </div>
                    <div>
                        <label class="field-label">Monthly Budget (USD)</label>
                        <input type="number" class="full" [(ngModel)]="scrape.monthlyBudgetUsd" />
                    </div>
                    <div>
                        <label class="field-label">Rescrape After (days)</label>
                        <input type="number" class="full" [(ngModel)]="scrape.rescrapeAfterDays" />
                    </div>
                    <div>
                        <label class="field-label">Safety Max Places / Run</label>
                        <input type="number" class="full" [(ngModel)]="scrape.safetyMaxPlacesPerRun" />
                    </div>
                    <div class="checkbox-field">
                        <label class="field-label">Scrape Contacts</label>
                        <label class="toggle">
                            <input type="checkbox" [(ngModel)]="scrape.scrapeContacts" />
                            <span class="toggle-slider"></span>
                        </label>
                    </div>
                </div>

                <div class="btn-row">
                    <button class="primary-btn" [disabled]="scrapeSaving" (click)="saveScrapeSettings()">
                        <i class="fa-solid" [class.fa-spinner]="scrapeSaving" [class.fa-spin]="scrapeSaving" [class.fa-floppy-disk]="!scrapeSaving"></i>
                        {{ scrapeSaving ? 'Saving...' : 'Save' }}
                    </button>
                </div>

                <div class="alert alert--ok" *ngIf="scrapeMessage">{{ scrapeMessage }}</div>
                <div class="alert alert--err" *ngIf="scrapeError">{{ scrapeError }}</div>
            </ng-container>
        </div>
    </div>

    <div class="card profile-hint">
        <i class="fa-solid fa-info-circle"></i>
        Email (SMTP) settings are configured per-user in your <a routerLink="/admin/profile">Admin Profile</a>.
    </div>
</div>
